<div [formGroup]="form" *ngIf="field.editable">
  <input
    class="form-control"
    mask="000-00-0000"
    [formControlName]="field.alias"
    type="text"
    [id]="'ba-'+ field.alias"
    [ngClass]="{'is-invalid':!control.valid && (control.touched || control.dirty)}"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
    (keydown)="onKeyDown($event)"
    [attr.disabled]="disabled ? '' : null"
  />
  <span
    class="invalid-feedback"
    *ngIf="control.hasError('minlength') && (control.touched || control.dirty)">
      Must be 9 digits
  </span>
  <span
    class="invalid-feedback"
    *ngIf="control.hasError('pattern') && (control.touched || control.dirty)">
      May only contain numbers
  </span>
</div>
<ng-container *ngIf="!field.editable && field.value">
  {{ field.value }}
</ng-container>
